/** Back in stock
* custom notify-popup
* https://help.backinstock.org/article/2303-javascript-api
**/
class NotifyMe extends HTMLElement {
    constructor() {
        super();
        this.trigger         = this.closest('.product-form__buttons').querySelector(".notify_button");
        this.buttonSubmit    = this.querySelector('#notify_me');
        this.privacyField    = this.querySelector('.notify-me__privacy');
        this.privacy         = this.querySelector('#notify__privacy');
        this.email           = this.querySelector('#notify_email');
        this.select          = this.querySelector('#notify_variant');
        this.dialog          = this.querySelector(".dialog__notify-me");
        this.dialogContainer = this.querySelector('.dialog__body');
        this.dialog_notify   = this.querySelector(".dialog__success");
        this.email_error     = this.querySelector(".error_notification");
        this.close_dialog    = this.querySelector("#close-notify");
        const variantsScript = this.closest('montura-quick-buy')?.querySelector('.all-variants')
            || document.querySelector('.all-variants');
        this.variants        = JSON.parse(variantsScript.innerText);
        this.product_id      = this.select.dataset.product;
        this.color           = this.select.dataset.color;

        this.buildSelect(this.findVariants(this.color));

        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            this.buildSelect(this.findVariants(event.data.variant.option1));
        });

        this.addEvents();

        document.addEventListener("click", this.closeDialog.bind(this));
    }

    buildSelect(variants){
        this.select.innerHTML = '';

        // Create and append new options
        for (var i = 0; i < variants.length; i++) {
            let option = document.createElement("option");
            option.text = variants[i].title;
            option.value = variants[i].id; // You can set the value to whatever you need
            this.select.add(option);
        }

        this.select.value = this.getSelectedVariant();
    }

    getSelectedVariant(){
        const quickBuyVariantId = this.closest('montura-quick-buy')?.querySelector('[data-quick-buy-variant-input]')?.value;
        if (quickBuyVariantId) return quickBuyVariantId;
        return new URLSearchParams(window.location.search).get('variant');
    }

    /** Syncs size options when color changes in montura-quick-buy. */
    updateForColor(color) {
        if (!color) return;
        this.color = color;
        this.select.dataset.color = color;
        this.buildSelect(this.findVariants(color));
    }

    findVariants(color){
        // effettuare il controllo su color se presente all'interno di return
        //Object.entries(this.allVariants)
        const object = Object.entries(this.variants)
        .filter(([key, value]) => (value.option1 === color && value.available == false))
        .map(([key, value]) => value);

        return object;
    }

    openDialog() {
        this.dialog.showModal();
    }
    
    closeDialog(event) {
        // If the target dialog is
        if (event.target.matches("#close-notify, #close-notify *") || event.target.matches(".dialog__success button, .dialog__success button label")){
            this.dialog.close();
        }
        if (!event.target.contains(this.dialog)) return;
        this.dialog.close();
    }

    addEvents() {
        const self = this;
        this.trigger.addEventListener('click', e=> {
            e.preventDefault();
            this.dialogContainer.classList.remove("tw-hidden");
            this.dialog_notify.classList.add("tw-hidden");

            self.openDialog();
        })
        this.buttonSubmit.addEventListener('click', async (event)=> {
            event.preventDefault();
                this.createBIS.bind(this)()
        })

        this.email.addEventListener("click", ()=>{
            if(this.email.closest(".field_email").classList.contains("field--error")){
                this.email.closest(".field_email").classList.remove("field--error");
                this.email_error.classList.add("tw-hidden");
            }
        });
        this.privacyField.addEventListener("click", ()=>{
            if(this.privacyField.classList.contains("field--error")){
                this.privacyField.classList.remove("field--error")
            }
        });
        this.close_dialog.addEventListener("click", this.closeDialog.bind(this));
    }

    async createBIS() {

        this.privacyField.classList.toggle('field--error', !this.privacy.checked);
        if (!this.privacy.checked) {
            return
        }
        const email       = this.email.value,
            variantId   = this.select.value;

        const email_regex = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|'(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*')@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;

        if (!email.match(email_regex)) {
            this.email.closest(".field_email").classList.add('field--error');
            this.email_error.classList.remove("tw-hidden");
            return
        }

        this.email.closest(".field_email").classList.remove('field--error');
        // Back in stock API
        const data = {
            data: {
                type: "back-in-stock-subscription",
                attributes: {
                    channels: ['EMAIL'],
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                email: `${email}`
                            }
                        }
                    }
                },
                relationships: {
                    variant: {
                        data: {
                            type: "catalog-variant",
                            id: `$shopify:::$default:::${variantId}`
                        }
                    }
                }
            }
        }


       await fetch(window.klaviyo.api, {
            method: "POST",
            headers: {
                "accept": "application/vnd.api+json",
                "content-type": "application/vnd.api+json",
                "revision": "2024-10-15",
            },
            body: JSON.stringify(data),
        })
        this.notificationCallback()

        fbq('track', 'CompleteRegistration');

    }


    notificationCallback(){
        this.classList.add('notification');
        this.dialogContainer.classList.add("tw-hidden");
        this.dialog_notify.classList.remove("tw-hidden");
        this.email.value = "";
    }
}
customElements.define('notify-me', NotifyMe);